// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"23":"fc85de2e","54":"0e9a6bfc","61":"7d261a83","78":"5a614dbf","182":"07ece654","298":"60be0065","399":"b463530a","496":"c53690f0","630":"7fc6e3a5","669":"22ce8fa2","766":"0e51e09d","831":"da460996"}[chunkId] + ".js";
};